export default "__VITE_ASSET__676f401b__"